import { Typography } from '@material-ui/core'
import React from 'react'

import { gregorianToJalaaliWithHourMinuteAndSecond } from '../../helpers/date'
import { addCommaToPrice } from '../../helpers/numbers'
import { persianRegex } from '../../helpers/regex'
import { getTranslate, lang } from '../../localization'
import { Currency } from '../../types/currency'
import { WalletTransaction } from '../../types/walletTransaction'
import useStyles from './styles/TransactionList.styles'

interface TransactionListRowProps {
  data: WalletTransaction
  index: number
  currency: Currency
}

export const TransactionListRow: React.FC<TransactionListRowProps> = ({
  data,
  index,
  currency
}) => {
  const classes = useStyles()

  const isPersianSenderWallet =
    data.walletID && persianRegex.test(data.correlationID)

  return (
    <div className={[classes.tableRowRoot].join(' ')}>
      <div className={classes.tableRowWithoutCreditor}>
        <Typography variant="h4">{index + 1}</Typography>
        <div
          className={classes.nameCell}
          style={
            isPersianSenderWallet ? { fontFamily: 'IranSans' } : undefined
          }>
          <Typography variant="h4">
            {lang === 'fa'
              ? gregorianToJalaaliWithHourMinuteAndSecond(data.time)
              : data.time}
          </Typography>
        </div>

        <div>
          <Typography variant="body1">{data.reservationNumber}</Typography>
        </div>
        <div className={classes.flex}>
          <Typography variant="body1">
            {addCommaToPrice(data.amount) + ` ${getTranslate(currency || '')}`}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {lang === 'fa'
              ? gregorianToJalaaliWithHourMinuteAndSecond(data.dueDate || '')
              : data.dueDate}
          </Typography>
        </div>
        <div>
          <Typography
            variant="body1"
            className={
              data.sumOfPenalty > 0
                ? classes.penaltyText
                : data.rewardOfEarlyPayment > 0
                ? classes.rewardText
                : undefined
            }>
            {data.sumOfPenalty > 0
              ? '-' +
                addCommaToPrice(data.sumOfPenalty) +
                ` ${getTranslate(data.currency || '')}`
              : data.rewardOfEarlyPayment > 0
              ? '+' +
                addCommaToPrice(data.rewardOfEarlyPayment) +
                ` ${getTranslate(data.currency || '')}`
              : '0'}
          </Typography>
        </div>
      </div>
    </div>
  )
}
